<template>
  <a-modal
    title="收款信息"
    :confirm-loading="confirmLoading"
    @ok="confirm"
    v-model="Visible"
    :afterClose="
      () => {
        $emit('close');
      }
    "
  >
    <a-form-model ref="form" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <a-form-model-item label="账户欠款" prop="username">
        <span style="color: red;">€{{ parseInt($parent.$parent._data.user.amount_owed) / 100 }}</span>
      </a-form-model-item>
      <a-form-model-item label="实际收款" prop="amount" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model="form.amount" />
      </a-form-model-item>
      <a-form-model-item label="收款方式" prop="pay_method" :rules="[{ required: true, message: '请输入' }]">
        <a-select v-model="form.pay_method">
          <a-select-option v-for="val in options.methods" :value="val">{{ val }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="到账日期" prop="arrival_time" :rules="[{ required: true, message: '请输入' }]">
        <a-date-picker valueFormat="YYYY/MM/DD" v-model="form.arrival_time" />
      </a-form-model-item>
      <a-form-model-item label="到账银行" prop="bank">
        <a-select v-model="form.bank">
          <a-select-option v-for="val in options.banks" :value="val">{{ val }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" type="textarea" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import Member from '@/api/member';
export default {
  name: 'RepayModel',
  props: {
    show: Boolean,
  },
  data() {
    return {
      confirmLoading: false,
      Visible: false,
      options: {
        methods: [],
        banks: [],
      },
      form: {
        user_id: '',
        username: '',
        amount: '',
        pay_method: '',
        arrival_time: '',
        bank: '',
        remark: '',
        s_admin: localStorage.getItem('operator_id'),
      },
    };
  },
  watch: {
    show() {
      this.Visible = this.show;
    },
    Visible(res) {
      if (res) {
        this.form.user_id = this.$parent.$parent._data.id;
      }
    },
  },
  created() {
    Member.repayMethod().then(res => {
      this.options.methods = res.data;
    });
    Member.repayBank().then(res => {
      this.options.banks = res.data;
    });
  },
  methods: {
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmLoading = true;
          Member.repay(this.form).then(res => {
            this.confirmLoading = false;
            if (res.code == 0) {
              this.Visible = false;
              this.$message.success(res.msg);
              this.$emit('success');
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
  },
  mounted() {},
};
</script>
